/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the OrderProfitabilityUpdateRequestDTO interface.
 */
export function instanceOfOrderProfitabilityUpdateRequestDTO(value) {
    return true;
}
export function OrderProfitabilityUpdateRequestDTOFromJSON(json) {
    return OrderProfitabilityUpdateRequestDTOFromJSONTyped(json, false);
}
export function OrderProfitabilityUpdateRequestDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'salePriceUsd': json['salePriceUsd'] == null ? undefined : json['salePriceUsd'],
        'salesTaxUsd': json['salesTaxUsd'] == null ? undefined : json['salesTaxUsd'],
        'promotionUsd': json['promotionUsd'] == null ? undefined : json['promotionUsd'],
        'productCostUsd': json['productCostUsd'] == null ? undefined : json['productCostUsd'],
        'warehouseCostUsd': json['warehouseCostUsd'] == null ? undefined : json['warehouseCostUsd'],
        'referralFeeUsd': json['referralFeeUsd'] == null ? undefined : json['referralFeeUsd'],
        'giftCardUsd': json['giftCardUsd'] == null ? undefined : json['giftCardUsd'],
        'extraCostUsd': json['extraCostUsd'] == null ? undefined : json['extraCostUsd'],
        'couponUsd': json['couponUsd'] == null ? undefined : json['couponUsd'],
        'refundUsd': json['refundUsd'] == null ? undefined : json['refundUsd'],
    };
}
export function OrderProfitabilityUpdateRequestDTOToJSON(json) {
    return OrderProfitabilityUpdateRequestDTOToJSONTyped(json, false);
}
export function OrderProfitabilityUpdateRequestDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'salePriceUsd': value['salePriceUsd'],
        'salesTaxUsd': value['salesTaxUsd'],
        'promotionUsd': value['promotionUsd'],
        'productCostUsd': value['productCostUsd'],
        'warehouseCostUsd': value['warehouseCostUsd'],
        'referralFeeUsd': value['referralFeeUsd'],
        'giftCardUsd': value['giftCardUsd'],
        'extraCostUsd': value['extraCostUsd'],
        'couponUsd': value['couponUsd'],
        'refundUsd': value['refundUsd'],
    };
}
